module.exports = __webpack_public_path__ + "static/media/NZD.b141a309.png";